const Language = ({ language }) => <UI.Text>{language}</UI.Text>;

Language.displayName = 'Build.Language';

export default Language;
